import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Container from '../../container';
import Section from '../../section';
import ShareList from '../../share-list';
import StatGrid from '../../stat-grid';
import TextWave from '../../text-wave';
import Waves from '../../waves';

const formatStats = stats => [
  {
    value: (stats.donated && stats.donated.formatted) || '$0',
    title: 'Total Donations',
  },
  {
    value: stats.couriers,
    title: 'Courier Projects',
  },
  {
    value: stats.filtersRaised,
    title: `Filter${stats.filtersRaised > 1 ? 's' : ''} Raised`, // TODO => update conditional based on API data
  },
  {
    value: stats.peopleImpacted,
    title: 'People Impacted',
  },
];

const AccountImpact = ({ totals, shareURL }) => (
  <Section dark styles="position: relative; text-align: center; padding-bottom: 1px;">

    <AccountContainer>
      <TextWave>
        <h2>Personal Impact</h2>
      </TextWave>

      {totals &&
        <AccountStats>
          <StatGrid stats={formatStats(totals)} />
        </AccountStats>
      }

      <ShareList
        twitterShareMessage={shareURL}
        fbShareMessage={shareURL}
        isDark
      />

    </AccountContainer>
    <Waves
      inverted
      position="bottom"
      alignment="bottom"
      height={240}
      color="#fff"
    />
  </Section>
);

const AccountContainer = styled(Container)`
  ${screen.above(bp.desktop, `
    padding-bottom: 7%;
    position: relative;
    z-index: 2;
  `)}
`;

const AccountStats = styled.div`
  margin-top: 80px;

  ${screen.below(bp.mobileSm, `
    margin-top: 40px;
  `)};
`;

AccountStats.propTypes = {
  totals: PropTypes.array,
};

export default AccountImpact;
